{
    "Profile_Policy_Servicing.servicingStats": "FR: Servicing Stats",
    "Profile_Policy_Servicing.participantDetails": "FR: Particpant Details",
    "Profile_Policy_Servicing.insurer": "FR: Insurer",
    "Profile_Policy_Servicing.previousInsurer": "FR: Previous Insurer",
    "Profile_Policy_Servicing.broker": "FR: Broker",
    "Profile_Policy_Servicing.partner": "FR: Partner",
    "Profile_Policy_Servicing.epicLookupCode": "FR: Epic Lookup Code"
}
